namespace $.$$ {
	export class $eve_app_page_components_link extends $.$eve_app_page_components_link {}
}
